import { render, staticRenderFns } from "./UsuariosForm.vue?vue&type=template&id=e6a1dde4&"
import script from "./UsuariosForm.vue?vue&type=script&lang=js&"
export * from "./UsuariosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports